import React, { createContext, useContext, useEffect } from 'react'

// Masonyt is light-theme only. The ThemeProvider exists for compatibility with
// existing imports but forces `light` on every render and ignores localStorage,
// system preference, and any `defaultTheme` prop passed in.

type Theme = 'light'

interface ThemeProviderProps {
  children: React.ReactNode
  // Kept for backwards compatibility with existing call sites; ignored.
  defaultTheme?: string
  storageKey?: string
}

interface ThemeProviderState {
  theme: Theme
  setTheme: (theme: Theme) => void
}

const initialState: ThemeProviderState = {
  theme: 'light',
  setTheme: () => null,
}

const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove('dark')
    root.classList.add('light')
  }, [])

  return (
    <ThemeProviderContext.Provider {...props} value={initialState}>
      {children}
    </ThemeProviderContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider')

  return context
}
